import { LocaleType } from "./LocaleType";

export const de: LocaleType = {
    loading: "Laden",
    about: "Über",
    tutorial: "Anleitung",
    send: "Senden",
    welcome: "Willkommen",
    onboarding: "Einführung",
    connected: "Verbunden",
    disconnected: "Getrennt",
    strange_noises: "Seltsame Geräusche",
    you_can_start_anew: "Sie können neu anfangen",

    your_nick: "Dein Spitzname...",
    welcome_back: "Willkommen zurück",
    draw_something_special: "Zeichne eine Linie!",

    blocked_notice: "Du wurdest permanent geblockt.",
    rejected_notice: "Ich habe das Gefühl, dass du etwas Unangemessenes zeichnest.",
    accepted_notice: "Wir haben das Bild überprüft und es ist in Ordnung, danke!",

    anonymous_mode_notice: "Diese Anwendung funktioniert nicht im anonymen Modus.",
    connection_error: "Verbindungsfehler",

    about_you: "Über dich",
    about_you_hint: "Diese Anwendung ist anonym, aber du kannst uns etwas über dich erzählen, wenn du möchtest. Zum Beispiel, was deine Lieblingsfarbe ist oder was dich hierher gebracht hat. Deine Informationen helfen uns zu verstehen, wer unsere Anwendung benutzt und wie wir sie verbessern können.",

    select_color: "Farbe auswählen",
    too_short_notice: "Das war zu kurz - versuche eine längere Linie!",
    too_small_notice: "Zeichne etwas Größeres!"
}